export const CHAT_ID = 'chatId';
export const MESSAGE_ID = 'messageId';
export const COMMENT = 'comment';
export const REASONS = 'reasons';

export const REASON_INCORRECT_INFORMATION = 1;
export const REASON_INSTRUCTION_IGNORED = 2;
export const REASON_IRRELEVANT_RESPONSE = 3;
export const REASON_OTHER = 4;
